import { AdminPageHeader } from '@/components/patterns/admin-page'
import CustomerForm from '@/components/forms/CustomerForm'
import {
  customerQueries,
  useCustomerBillingDefaults,
} from '@/lib/services/customers/customers.query'
import { createFileRoute, notFound, useParams } from '@tanstack/react-router'
import { UserPlus } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/customers/create')({
  beforeLoad: ({ context }) => {
    if (!context.ability.can('create', 'customers')) throw notFound()
  },
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      customerQueries.billingDefaults({ organizationId: params.orgId })
    )

    return { isReadOnly: false }
  },
  component: CustomerCreatePage,
})

export function CustomerCreatePage() {
  const { orgId } = useParams({ strict: false })
  const { data: billingDefaults } = useCustomerBillingDefaults({ organizationId: orgId })

  return (
    <div className="space-y-4">
      <AdminPageHeader icon={UserPlus} title="Create New Customer" />
      <CustomerForm billingDefaults={billingDefaults} />
    </div>
  )
}
